import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ParabensHero from "@/components/parabens/ParabensHero";
import AccessBlock from "@/components/parabens/AccessBlock";
import QuickSteps from "@/components/parabens/QuickSteps";
import PersonalTouch from "@/components/parabens/PersonalTouch";
import StickyDownloadCTA from "@/components/parabens/StickyDownloadCTA";

const Parabens = () => {
  useEffect(() => {
    // SEO: Update page title and meta description
    document.title = "Parabéns! Sua compra foi confirmada - 30 Receitas Express";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Parabéns! Você tem acesso imediato ao e-book 30 Receitas Express. Baixe agora e comece a cozinhar refeições deliciosas em até 30 minutos."
      );
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header hideCheckoutButton />
      <main>
        <ParabensHero />
        <AccessBlock />
        <QuickSteps />
        <PersonalTouch />
      </main>
      <Footer />
      <StickyDownloadCTA />
    </div>
  );
};

export default Parabens;
